import { createApi } from '@reduxjs/toolkit/query/react'
import { ASSIGN_APPRENTICE, UNASSIGN_APPRENTICE } from 'config/apiPaths';
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const apprenticeApi = createApi({
    reducerPath: 'apprenticeApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/client",
    }),
    tagTypes: [],
    endpoints: (builder) => ({

        // chatter client details
        assignApprentice: builder.mutation({
            query: ({ caseloadId, therapistId, apprentice, currentApprenticeId }) => ({
                method: "PUT",
                url: `${ASSIGN_APPRENTICE}/${caseloadId}/${therapistId}/${apprentice}/${currentApprenticeId}`
            })
        }),

        // chatter client details
        deleteApprentice: builder.mutation({
            query: ({ caseloadId, currentApprenticeId, therapistId }) => ({
                method: "PUT",
                url: `${UNASSIGN_APPRENTICE}/${caseloadId}/${therapistId}/${currentApprenticeId}`
            })
        }),

        // clients list lookup
        // getClientsListLookup: builder.query({
        //     query: ({ type, data }) => ({
        //         method: "PATCH",
        //         url: `/${type}/list`,
        //         data
        //     })
        // }),
    })
})

export const {
    useAssignApprenticeMutation,
    useDeleteApprenticeMutation
} = apprenticeApi;